<template>
  <div>
    <!-- <img alt="Vue logo" src="../assets/rdp-logo-white.png" /> -->
    <div class="ui breadcrumb">
      <a class="section">
        <router-link class="item" :to="{ name: 'home' }">Home</router-link>
      </a>
    </div>
    <div class="ui items">
      <div class="item">
        <div class="image">
        
        </div>
        <div class="content">
          <a class="header">Header</a>
          <div class="meta">
            <span>Description</span>
          </div>
          <div class="description">
            <p></p>
          </div>
          <div class="extra">Additional Details</div>
        </div>
      </div>
      <div class="item">
        <div class="image">
          
        </div>
        <div class="content">
          <a class="header">Header</a>
          <div class="meta">
            <span>Description</span>
          </div>
          <div class="description">
            <p></p>
          </div>
          <div class="extra">Additional Details</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import contract from "@/views/Contract.vue";
import { eventBus } from '@/main.js';

export default {
  name: "home",
  mounted() {
    this.init();
  },
  methods: {
    init() {
      eventBus.$emit('accFeeContext', 0);
    }
  }
  // components: {
  //   contract
  // }
};
</script>
